export default "__VITE_ASSET__DHi69ifH__"